// src/hooks/useAnalyticsEvent.ts
import { getAnalytics, logEvent } from 'firebase/analytics';

export function useAnalyticsEvent() {
  return (eventName: string, params?: Record<string, any>) => {
    try {
      const analytics = getAnalytics();
      logEvent(analytics, eventName, params);
    } catch (e) {
      // Optionally handle analytics errors
      console.error('Analytics event logging failed:', e);
    }
  };
}